module.exports = __webpack_public_path__ + "img/ying.dfac73e5.png";